import { useMsal } from '@azure/msal-react';
import { useRole } from '@auth/RoleContext';
import { isDevAuthBypass } from '@auth/index';

/**
 * Header — top bar showing the app name, the signed-in identity, the user's App
 * Roles, and sign-out. Role chips make the active authorization tier visible
 * (architecture §4 — Warehouse vs Admin).
 */
export function Header() {
  const { instance } = useMsal();
  const { user, roles } = useRole();

  const onSignOut = () => {
    if (isDevAuthBypass()) return; // nothing to sign out of in dev bypass
    void instance.logoutRedirect();
  };

  return (
    <header
      style={{
        height: 56,
        background: '#0A1220',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 18px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
        <span style={{ fontWeight: 700, letterSpacing: '0.02em' }}>ClariDynamics Shipping</span>
        <span style={{ fontSize: 11, color: '#8FA0BC', textTransform: 'uppercase', letterSpacing: '0.14em' }}>
          Warehouse Control Plane
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        {roles.map((r) => (
          <span
            key={r}
            style={{
              fontSize: 11,
              fontWeight: 600,
              padding: '2px 8px',
              borderRadius: 10,
              background: r === 'Admin' ? '#3A2C6B' : '#1E4A45',
              color: '#fff',
            }}
          >
            {r}
          </span>
        ))}
        <span style={{ fontSize: 12, color: '#C4CFE0' }}>{user?.displayName ?? 'Not signed in'}</span>
        {!isDevAuthBypass() && (
          <button
            type="button"
            onClick={onSignOut}
            style={{
              fontSize: 12,
              color: '#C4CFE0',
              background: 'transparent',
              border: '1px solid #34425C',
              borderRadius: 6,
              padding: '3px 10px',
              cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        )}
      </div>
    </header>
  );
}
